export function normalizeUsername(value) {
  return String(value ?? "").toLowerCase().replace(/\s+/g, "");
}

export function normalizePassword(value) {
  return String(value ?? "").replace(/\s+/g, "");
}
